<div class="flex justify-between md:gap-2">
	<button *ngIf="product.volumeDiscountProfileEnabled"
			(click)="openPreOrderDialog()"
			class="w-full fb-pre-order secondary-button">Pre-Order</button>
	<button class="w-full fb-add-to-cart primary-button">Add to Cart</button>
</div>
